import { SimpleTabs } from '@dreamstack/simple-components'
import type { FunctionComponent } from 'react'

const tabsData = [
  {
    title: 'Local Buyer',
    content: `Depending on your visa situation, you can often secure up to 100% of the purchase price from a German bank, 
    providing the property price is ok and your personal income situation is good. Interest rates can be fixed for 5, 
    10, 15 or even 20 years, at a range of 2.5 - 4.5% depending on circumstance.`,
  },
  {
    title: 'International Buyer',
    content: `As a tax-foreigner, you can often secure up to 70% LTV financing, 
    though 60% is more achievable and there is a noticeable interest decrease at 54%. 
    Depending on your place of residence, you can expect interest rates between 2.5 - 4.5%. 
    There are, however, some countries that are still not able to finance through a German bank.`,
  },
]

export const BasicMortgageTabs: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  return (
    <SimpleTabs
      tabs={[
        { title: tabsData[0].title, content: tabsData[0].content },
        { title: tabsData[1].title, content: tabsData[1].content },
      ]}
    />
  )
}
